import React from 'react';
import { Outlet } from 'react-router-dom';
import MixpanelSessionReplayManager from '@/components/MixpanelSessionReplayManager';
import ChatbotVisibilityManager from '@/components/ChatbotVisibilityManager';
import GlobalJoyride from '@/components/GlobalJoyride';

/**
 * Root layout wrapper that includes:
 * - Session replay management
 * - Chatbot visibility management
 */
const RootLayout = () => {
  return (
    <>
      <MixpanelSessionReplayManager />
      <ChatbotVisibilityManager />
      <GlobalJoyride />
      <Outlet />
    </>
  );
};

export default RootLayout;
